import React from 'react';
import { Link } from "react-router-dom";
import Img404 from "../../../assets/img/not-found.svg";

function NotFound() {

    return (
        <div className="container h-100">
            <div className="row justify-content-center h-100">
                <div className="col-12 col-lg-7 d-flex align-items-center justify-content-center flex-column h-100">
                    <img src={Img404} className="img-fluid mb-5" width={"100%"} alt="404 - Not Found"/>
                    <Link style={{borderRadius: "6px"}} to={"/dashboard"} className="btn bg-gradient-cyan-blue text-white font-poppins py-2 fz-18 d-flex justify-content-center w-25 ff-univanova-medium">Voltar ao início</Link>
                </div>
            </div>
        </div>
    );
}

export default NotFound;